import React from 'react'

const Copyright = ({photoData}) => {
  return (
    <div>{photoData}</div>
  )
}

export default Copyright